function interpolateRound(a, b) {
  a = +a, b = +b;
  var c = b - a;
  return function (b) {
    return Math.round(c * b + a);
  };
}

export default interpolateRound;